import React, { useCallback, useEffect, useRef, useState } from "react";
import Pagination from "./Pagination";
import NewsCard from "./NewsCard";
import { Link } from "react-router-dom";
import "../../Assets/Styles/serviceitem.css";
import { fetchNewsList } from "../../Utils/NewsHelper";

const Horizonscroll = () => {
  const scrollRef = useRef(null);
  const isDraggingRef = useRef(false);
  const startXRef = useRef(0);
  const startScrollLeftRef = useRef(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [inView, setInView] = useState(false);
  const [hovered, setHovered] = useState(null);
  const [timerKey, setTimerKey] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchNewsList();
        setData(result);
      } catch (error) {
        console.error(error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      {
        rootMargin: "0px",
        threshold: 0.5,
      },
    );

    if (scrollRef.current) {
      observer.observe(scrollRef.current);
    }

    return () => {
      if (scrollRef.current) {
        observer.unobserve(scrollRef.current);
      }
    };
  }, [loading]);

  // useEffect(() => {
  //     const handleScroll = () => {
  //         const itemWidth = scrollRef.current.scrollWidth / data?.length;
  //         const newIndex = Math.round(scrollRef.current.scrollLeft / itemWidth);
  //         setCurrentIndex(newIndex);
  //     };

  //     const throttleHandleScroll = () => {
  //         window.requestAnimationFrame(handleScroll);
  //     };

  //     if (scrollRef.current) {
  //         scrollRef.current.addEventListener('scroll', throttleHandleScroll);
  //     }

  //     return () => {
  //         if (scrollRef.current) {
  //             scrollRef.current.removeEventListener('scroll', throttleHandleScroll);
  //         }
  //     };
  // }, [data?.length]);

  const scrollToItem = useCallback(
    (index) => {
      if (!scrollRef.current) return;
      const itemWidth = scrollRef.current.scrollWidth / data?.length;
      const scrollLeft = index * itemWidth;
      scrollRef.current.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
      setCurrentIndex(index);
      setTimerKey((k) => k + 1);
    },
    [data?.length],
  );

  useEffect(() => {
    let timer;
    if (data?.length && inView && hovered === null) {
      timer = setTimeout(() => {
        scrollToItem(currentIndex < data?.length - 1 ? currentIndex + 1 : 0);
      }, 5000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [data, currentIndex, hovered, inView, scrollToItem, timerKey]);

  const handleDragStart = (e) => {
    e.preventDefault();
    isDraggingRef.current = true;
    const x = "touches" in e ? e.touches[0].pageX : e.pageX;
    startXRef.current = x - scrollRef.current.offsetLeft;
    startScrollLeftRef.current = scrollRef.current.scrollLeft;
  };

  const handleDragMove = (e) => {
    if (!isDraggingRef.current) return;
    const x = "touches" in e ? e.touches[0].pageX : e.pageX;
    const distance = x - scrollRef.current.offsetLeft - startXRef.current;
    scrollRef.current.scrollLeft = startScrollLeftRef.current - distance;
  };

  const handleDragEnd = () => {
    if (!scrollRef.current || !isDraggingRef.current) return;
    isDraggingRef.current = false;
    const itemWidth = scrollRef.current.scrollWidth / data?.length;
    const newIndex = Math.round(scrollRef.current.scrollLeft / itemWidth);
    scrollToItem(newIndex);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading data</div>;

  return (
    <div className="w-full">
      {data?.length > 0 && (
        <>
          <h2 className="text-5xl py-20 uppercase font-bold text-main">
            <Link to="/">News and Updates</Link>
          </h2>

          <div className="space-y-2">
            <div
              ref={scrollRef}
              className="relative flex w-full section-container my-auto overflow-x-scroll gap-[2.5rem]"
              style={{
                scrollSnapType: "x mandatory",
                overflowY: "hidden",
                borderRadius: "10px",
              }}
              onTouchStart={handleDragStart}
              onTouchMove={handleDragMove}
              onTouchEnd={handleDragEnd}
              onMouseDown={handleDragStart}
              onMouseMove={handleDragMove}
              onMouseUp={handleDragEnd}
              onMouseLeave={handleDragEnd}
            >
              {data.map((item, index) => (
                <NewsCard
                  key={index}
                  item={item}
                  handleHover={setHovered}
                  index={index}
                  currentIndex={currentIndex}
                />
              ))}
            </div>

            <Pagination
              handleHover={setHovered}
              actionHandler={scrollToItem}
              currentIndex={currentIndex}
              data={data}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Horizonscroll;
